import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mapOutsideMarker",
  "use": "mapOutsideMarker-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"mapOutsideMarker\"><g fill=\"none\"><path d=\"M15 3c3.31 0 6 2.66 6 5.95C21 13.41 15 20 15 20S9 13.41 9 8.95C9 5.66 11.69 3 15 3zm0 4a2 2 0 100 4 2 2 0 000-4z\" fill=\"#E65100\" /><path stroke=\"#E65100\" d=\"M10.676 17.115l1.769 2.971H4.034L7 17.115z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol